import { tap, takeUntil } from 'rxjs/operators';
import { Directive, ElementRef, Renderer2, OnDestroy } from '@angular/core';
import { fromEvent, Subject} from 'rxjs';

@Directive({
    selector: '[unhClearPasteFormating]',
})
export class ClearPasteFormatingDirective implements OnDestroy {
    private destroy$ = new Subject<void>();


    constructor(private _el: ElementRef, private renderer: Renderer2) {
        const paste$ = fromEvent(this._el.nativeElement, 'paste');
        paste$.pipe(
            tap((e: any) => {
                let txt = e.clipboardData.getData('text/plain');
                txt = txt.replace(/<[^>]*>/g, '');
                document.execCommand('insertText', false, txt);
                e.preventDefault();
            }),
            takeUntil(this.destroy$)
        ).subscribe();

     }

    
    ngOnDestroy() {
        this.destroy$.next();
    }
}
